import { useEffect, useState, useCallback } from "react";
import {
    useNavigate,
    useParams,
    useLocation
} from "react-router-dom";

import API from "../../api/api";

export default function TourDetails() {

    const { id } = useParams();

    const navigate = useNavigate();
const location = useLocation();

const isAdmin =
    location.pathname.startsWith("/admin");
    const [tour, setTour] = useState(null);
    const [guests, setGuests] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [adminNotes, setAdminNotes] = useState("");
const [guideNotes, setGuideNotes] = useState("");

const [uploading, setUploading] = useState(false);

const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(true);

    

    const load = useCallback(async () => {

        try {

            const sessionRes =
    await API.get(

        isAdmin

            ? `/admin/tour-sessions/${id}`

            : `/guide/tour-sessions/${id}`

    );
console.log("Available sessions:", sessionRes.data);
setTour(sessionRes.data);

           const detailRes =
    await API.get(

        isAdmin

            ? `/admin/guides/tour-sessions/${id}/details`

            : `/guide/tour-sessions/${id}/details`

    );
console.log("Detail response:", detailRes.data);
            setGuests(
                detailRes.data.guests || []
            );

           const ticketRes = await API.get(

    isAdmin

        ? `/admin/guides/tour-sessions/${id}/tickets`

        : `/guide/tour-sessions/${id}/tickets`

);

setTickets(ticketRes.data || []);

const notesRes = await API.get(

    isAdmin

        ? `/admin/guides/tour-sessions/${id}/notes`

        : `/guide/tour-sessions/${id}/notes`

);

setAdminNotes(
    notesRes.data.admin_notes || ""
);

setGuideNotes(
    notesRes.data.guide_notes || ""
);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    }, [id, isAdmin]);

    useEffect(() => {

        load();

    }, [load]);

    const uploadTicket = async () => {

    if (!selectedFile) return;

    const formData = new FormData();

    formData.append(
        "ticket",
        selectedFile
    );

    setUploading(true);

    try {

        await API.post(

            `/admin/guides/tour-sessions/${id}/ticket`,

            formData,

            {
                headers: {
                    "Content-Type":
                        "multipart/form-data"
                }
            }

        );

        setSelectedFile(null);

        load();

    }

    finally {

        setUploading(false);

    }

};

const saveNotes = async () => {

    try {

        await API.put(

    isAdmin

        ? `/admin/guides/tour-sessions/${id}/notes`

        : `/guide/tour-sessions/${id}/notes`,

    {

        admin_notes: adminNotes,

        guide_notes: guideNotes

    }

);

        alert("Notes saved");

    } catch (err) {

        console.error(err);

        alert("Unable to save notes");

    }

};

const openTicket = async (ticketId) => {

    const res = await API.get(

        isAdmin

            ? `/admin/guides/tickets/${ticketId}`

            : `/guide/tickets/${ticketId}`,

        {
            responseType: "blob"
        }

    );

    const url = window.URL.createObjectURL(res.data);

    window.open(url, "_blank");

};

const downloadTicket = async (ticketId) => {

    const res = await API.get(

        isAdmin

            ? `/admin/guides/tickets/${ticketId}`

            : `/guide/tickets/${ticketId}`,

        {
            responseType: "blob"
        }

    );

    const url = window.URL.createObjectURL(res.data);

    const a = document.createElement("a");

    a.href = url;

    a.download = "ticket.pdf";

    a.click();

};
const deleteTicket = async (ticketId) => {

    if (

        !window.confirm(

            "Delete this ticket?"

        )

    ) return;

    await API.delete(

        `/admin/guides/tickets/${ticketId}`

    );

    load();

};

    if (loading) {

        return (

            <div style={loadingStyle}>

                Loading...

            </div>

        );

    }

    if (!tour) {

        return (

            <div style={loadingStyle}>

                Tour not found

            </div>

        );

    }

   const stats = guests.reduce(
    (acc, g) => {

        acc.total += Number(g.total_guests);

        acc.adults += Number(g.adults);

        acc.children += Number(g.children);

        acc.youth += Number(g.youth);

        acc.infants += Number(g.infants);

        return acc;

    },
    {
        total: 0,
        adults: 0,
        children: 0,
        youth: 0,
        infants: 0
    }
);

    return (

        <div style={page}>

            <button
                onClick={() => {

    if (isAdmin) {

        navigate("/admin/tours");

    } else {

        navigate(-1);

    }

}}
                style={backButton}
            >

                ← Back

            </button>

          <div style={heroCard}>

    <div style={heroTop}>

        <div style={{ minWidth: 0, width: "100%" }}>

            <div style={tourLabel}>TOUR SESSION</div>

            <h1 style={{heroTitle,fontSize: window.innerWidth < 768 ? 28 : 42}}>
                {tour.title}
            </h1>

        </div>

        <div style={heroMetaRow}>

            <div style={heroDateTime}>

                <div style={heroDate}>
                    {new Date(tour.start_datetime).toLocaleDateString(
                        "en-GB",
                        {
                            weekday: "long",
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        }
                    )}
                </div>

                <div style={heroTime}>
                    🕒{" "}
                    {new Date(tour.start_datetime).toLocaleTimeString([],{
                        hour:"2-digit",
                        minute:"2-digit"
                    })}
                    {"  —  "}
                    {new Date(tour.end_datetime).toLocaleTimeString([],{
                        hour:"2-digit",
                        minute:"2-digit"
                    })}
                </div>

            </div>

            <div style={heroStatus}>
                <div style={capacityCircle}>
                    <strong>{tour.booked ?? 0}</strong>
                    <span>/ {tour.capacity ?? 0}</span>
                </div>
                <div style={capacityText}>Guests</div>
            </div>

        </div>

    </div>

    <div style={heroBottom}>

        <div style={infoChip}>

            👥 {tour.booked} Guests

        </div>

        <div style={infoChip}>

            🗣 {tour.languages || "No language"}

        </div>

        <div style={infoChip}>

    {isAdmin
        ? "🧑‍💼 Admin"
        : "🧑‍🏫 Guide"}

</div>

{!isAdmin && (
    <div style={infoChip}>
        🤝 Coordinator:{" "}
        {tour.coordinator_id
            ? `${tour.coordinator_first_name || ""} ${tour.coordinator_last_name || ""}`.trim()
            : "Unassigned"}
    </div>
)}

    </div>

</div>

         <div style={statsGrid}>

    <div style={statCard}>

        <div style={statIcon}>
            👥
        </div>

        <div>

            <div style={statValue}>

                {stats.total}

            </div>

            <div style={statLabel}>

                Total Guests

            </div>

        </div>

    </div>

    <div style={statCard}>

        <div style={statIcon}>
            👨
        </div>

        <div>

            <div style={statValue}>

                {stats.adults}

            </div>

            <div style={statLabel}>

                Adults

            </div>

        </div>

    </div>

    <div style={statCard}>

        <div style={statIcon}>
            🧑
        </div>

        <div>

            <div style={statValue}>

                {stats.youth}

            </div>

            <div style={statLabel}>

                Youth

            </div>

        </div>

    </div>

    <div style={statCard}>

        <div style={statIcon}>
            🧒
        </div>

        <div>

            <div style={statValue}>

                {stats.children}

            </div>

            <div style={statLabel}>

                Children

            </div>

        </div>

    </div>

    <div style={statCard}>

        <div style={statIcon}>
            👶
        </div>

        <div>

            <div style={statValue}>

                {stats.infants}

            </div>

            <div style={statLabel}>

                Infants

            </div>

        </div>

    </div>

</div>

            <div style={section}>

    <div style={sectionHeader}>

        <div>

            <div style={sectionEyebrow}>

                NOTES

            </div>

            <h2 style={sectionTitle}>

                Tour Communication

            </h2>

            <div style={sectionSubtitle}>

                Information shared between the office and the guide.

            </div>

        </div>

        <button
            style={saveButton}
            onClick={saveNotes}
        >

            💾 Save Notes

        </button>

    </div>

    <div style={notesCards}>

        <div style={noteCard}>

            <div style={noteHeader}>

                <span style={noteIcon}>

                    🧑‍💼

                </span>

                <div>

                    <strong>

                        Admin Notes

                    </strong>

                    <div style={noteDescription}>

                        Visible to the assigned guide.

                    </div>

                </div>

            </div>

            <textarea

                value={adminNotes}

                onChange={e =>
                    setAdminNotes(
                        e.target.value
                    )
                }

                readOnly={!isAdmin}

                style={noteTextarea}

                placeholder="Meeting point, special requests, VIP guests, timing changes..."

            />

        </div>

        <div style={noteCard}>

            <div style={noteHeader}>

                <span style={noteIcon}>

                    🧧

                </span>

                <div>

                    <strong>

                        Guide Report

                    </strong>

                    <div style={noteDescription}>

                        Tour feedback and incidents.

                    </div>

                </div>

            </div>

            <textarea

                value={guideNotes}

                onChange={e =>
                    setGuideNotes(
                        e.target.value
                    )
                }

                readOnly={isAdmin}

                style={noteTextarea}

                placeholder="How did the tour go? Any issues? Missing guests? Delays?"

            />

        </div>

    </div>

</div>


           <div style={{ ...section, padding: 14 }}>

    <div style={{ ...sectionHeader, marginBottom: 10 }}>

        <div>

            <div style={sectionEyebrow}>

                DOCUMENTS

            </div>

            <h2 style={sectionTitle}>

                Tour Tickets

            </h2>

            <div style={sectionSubtitle}>

                Museum tickets and supporting documents.

            </div>

        </div>

    </div>

    {

        isAdmin && (

            <div style={uploadCard}>

                <div>

                    <strong>

                        Upload Ticket

                    </strong>

                    <div style={uploadSubtitle}>

                        PDF, JPG or PNG

                    </div>

                </div>

                <div style={uploadControls}>

                    <input

                        type="file"

                        accept=".pdf,.jpg,.jpeg,.png"

                        onChange={e =>
                            setSelectedFile(
                                e.target.files[0]
                            )
                        }

                    />

                    <button

                        style={uploadButton}

                        disabled={
                            !selectedFile ||
                            uploading
                        }

                        onClick={uploadTicket}

                    >

                        {

                            uploading

                                ? "Uploading..."

                                : "Upload"

                        }

                    </button>

                </div>

            </div>

        )

    }

    {

        tickets.length === 0

            ?

            <div style={emptyTicket}>

                📄

                <h3>

                    No Tickets Uploaded

                </h3>

                <p>

                    Upload museum tickets here so guides can access them before the tour.

                </p>

            </div>

            :

            <div style={ticketGrid}>

                {

                    tickets.map(ticket => (

                        <div
                            key={ticket.id}
                            style={ticketCard}
                        >

                            <div style={ticketIcon}>

                                📄

                            </div>

                            <div style={{flex:1}}>

                                <strong>

                                    Tour Ticket

                                </strong>

                                <div style={ticketMeta}>

                                    Uploaded

                                </div>

                            </div>

                            <div style={ticketActions}>

                                <button

                                    style={smallAction}

                                    onClick={() =>
                                        openTicket(ticket.id)
                                    }

                                >

                                    👁

                                </button>

                                <button

                                    style={smallAction}

                                    onClick={() =>
                                        downloadTicket(ticket.id)
                                    }

                                >

                                    ⬇

                                </button>

                                {

                                    isAdmin && (

                                        <button

                                            style={deleteAction}

                                            onClick={() =>
                                                deleteTicket(ticket.id)
                                            }

                                        >

                                            🗑

                                        </button>

                                    )

                                }

                            </div>

                                                    </div>

                       

                    ))

                }

            </div>

    }

</div>

<div style={section}>

    <div style={sectionHeader}>

        <div>

            <div style={sectionEyebrow}>

                BOOKINGS

            </div>

            <h2 style={sectionTitle}>

                Guest List

            </h2>

            <div style={sectionSubtitle}>

                {guests.length} booking{guests.length !== 1 ? "s" : ""} for this tour.

            </div>

        </div>

    </div>

    {

        guests.length === 0

            ?

            <div style={emptyGuests}>

                <div style={emptyGuestsIcon}>

                    👥

                </div>

                <h3>

                    No Guests Yet

                </h3>

                <p>

                    As soon as someone books this tour they will appear here.

                </p>

            </div>

            :

            guests.map(g => (

                <div

                    key={g.booking_id}

                    style={guestCardNew}

                >

                    <div style={guestTop}>

                        <div style={guestAvatar}>

                            {g.first_name?.charAt(0)}

                            {g.last_name?.charAt(0)}

                        </div>

                        <div style={{flex:1}}>

                            <h3 style={guestTitle}>

                                {g.first_name} {g.last_name}

                            </h3>

                            <div style={guestBookingInfo}>

                                Booking #{g.booking_id}

                            </div>

                        </div>

                        <div style={bookingBadge}>

                            👥 {g.total_guests}

                        </div>

                    </div>

                    <div style={passengerRow}>

                        {

                            Number(g.adults) > 0 && (

                                <span style={passengerChip}>

                                    👨 {g.adults} Adults

                                </span>

                            )

                        }

                        {

                            Number(g.youth) > 0 && (

                                <span style={passengerChip}>

                                    🧑 {g.youth} Youth

                                </span>

                            )

                        }

                        {

                            Number(g.children) > 0 && (

                                <span style={passengerChip}>

                                    🧒 {g.children} Children

                                </span>

                            )

                        }

                        {

                            Number(g.infants) > 0 && (

                                <span style={passengerChip}>

                                    👶 {g.infants} Infants

                                </span>

                            )

                        }

                    </div>

                    <div style={contactRow}>

                    

    <div>

        📞 {g.phone || "-"}

    </div>

</div>

                </div>

            ))

    }

</div>

                 

        </div>

    );

}


const page = {
  padding: "20px",
  background: "#f5f6f8",
  minHeight: "100vh",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  overflowX: "hidden",
  color: "#172033"
};

const loadingStyle = {
  padding: 40,
  textAlign: "center",
  color: "#718096"
};

const backButton = {
  display: "inline-flex",
  alignItems: "center",
  gap: 7,
  border: "1px solid #dce2e9",
  background: "#ffffff",
  color: "#344054",
  fontSize: 13,
  fontWeight: 650,
  padding: "9px 13px",
  borderRadius: 8,
  marginBottom: 16,
  cursor: "pointer"
};

const section = {
  background: "#ffffff",
  border: "1px solid #dce2e9",
  borderRadius: 12,
  padding: 20,
  marginBottom: 16,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.03)",
  minWidth: 0,
  boxSizing: "border-box"
};

const heroCard = {
  background: "linear-gradient(135deg, #c75028 0%, #e87532 100%)",
  color: "#ffffff",
  border: "1px solid #c75028",
  borderRadius: 12,
  padding: 22,
  marginBottom: 16,
  boxShadow: "0 8px 20px rgba(199, 80, 40, 0.16)"
};

const heroTop = {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: 10
};

const heroMetaRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 18,
  flexWrap: "wrap"
};

const heroDateTime = {
  display: "flex",
  flexDirection: "column",
  gap: 5,
  minWidth: 0
};

const heroBottom = {
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
  marginTop: 16,
  paddingTop: 13,
  borderTop: "1px solid rgba(255,255,255,0.25)"
};

const heroTitle = {
  margin: "7px 0 8px",
  fontSize: 27,
  lineHeight: 1.25,
  fontWeight: 750,
  color: "#ffffff",
  letterSpacing: "-0.4px",
  overflowWrap: "anywhere"
};

const heroDate = {
  color: "rgba(255,255,255,0.96)",
  fontSize: 14,
  fontWeight: 650,
  marginBottom: 5
};

const heroTime = {
  color: "rgba(255,255,255,0.88)",
  fontSize: 13,
  fontWeight: 550
};

const tourLabel = {
  fontSize: 10,
  letterSpacing: 1.2,
  fontWeight: 750,
  color: "rgba(255,255,255,0.86)"
};

const heroStatus = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: 9,
  flexShrink: 0,
  padding: "9px 13px",
  borderRadius: 9,
  background: "rgba(255,255,255,0.14)",
  border: "1px solid rgba(255,255,255,0.28)"
};

const capacityCircle = {
  minWidth: 62,
  height: 38,
  padding: "0 10px",
  boxSizing: "border-box",
  borderRadius: 8,
  background: "#ffffff",
  color: "#172033",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: 2,
  fontSize: 20,
  lineHeight: 1,
  fontWeight: 800,
  whiteSpace: "nowrap"
};

const capacityText = {
  marginTop: 0,
  fontWeight: 650,
  color: "#ffffff",
  fontSize: 12,
  whiteSpace: "nowrap"
};

const infoChip = {
  padding: "7px 11px",
  background: "rgba(255,255,255,0.14)",
  border: "1px solid rgba(255,255,255,0.24)",
  borderRadius: 7,
  color: "#ffffff",
  fontWeight: 550,
  fontSize: 12
};

const statsGrid = {
  display: "grid",
  gridTemplateColumns:
    window.innerWidth < 768
      ? "repeat(2, minmax(0, 1fr))"
      : "repeat(auto-fit, minmax(145px, 1fr))",
  gap: 10,
  marginBottom: 16
};

const statCard = {
  background: "#ffffff",
  border: "1px solid #dce2e9",
  borderRadius: 10,
  padding: 14,
  display: "flex",
  alignItems: "center",
  gap: 12,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.02)",
  minWidth: 0
};

const statIcon = {
  width: 38,
  height: 38,
  flexShrink: 0,
  borderRadius: 9,
  background: "#fff3ed",
  color: "#c75028",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 18
};

const statValue = {
  fontSize: 22,
  fontWeight: 750,
  lineHeight: 1.1,
  color: "#172033"
};

const statLabel = {
  color: "#718096",
  marginTop: 4,
  fontWeight: 550,
  fontSize: 12
};

const sectionHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16,
  gap: 14,
  flexWrap: "wrap"
};

const sectionEyebrow = {
  color: "#c75028",
  fontSize: 10,
  fontWeight: 750,
  letterSpacing: 1.1,
  marginBottom: 5
};

const sectionTitle = {
  margin: 0,
  fontSize: 19,
  lineHeight: 1.3,
  fontWeight: 750,
  color: "#172033"
};

const sectionSubtitle = {
  marginTop: 5,
  color: "#718096",
  fontSize: 12,
  lineHeight: 1.45
};

const saveButton = {
  padding: "9px 13px",
  background: "#c75028",
  color: "#ffffff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 650,
  fontSize: 12
};

const notesCards = {
  display: "grid",
  gridTemplateColumns: window.innerWidth < 768 ? "1fr" : "repeat(2, minmax(0, 1fr))",
  gap: 12,
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box"
};

const noteCard = {
  background: "#f8fafc",
  borderRadius: 9,
  padding: 15,
  border: "1px solid #e5eaf0",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box"
};

const noteHeader = {
  display: "flex",
  gap: 11,
  alignItems: "center",
  marginBottom: 12
};

const noteIcon = {
  width: 36,
  height: 36,
  flexShrink: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 8,
  background: "#fff3ed",
  color: "#c75028",
  fontSize: 18
};

const noteDescription = {
  color: "#718096",
  marginTop: 3,
  fontSize: 11
};

const noteTextarea = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  minHeight: 145,
  borderRadius: 8,
  border: "1px solid #d5dce5",
  background: "#ffffff",
  color: "#263247",
  padding: 12,
  fontSize: 13,
  resize: "vertical",
  lineHeight: 1.5,
  fontFamily: "inherit",
  boxSizing: "border-box",
  display: "block",
  outlineColor: "#c75028"
};

const uploadCard = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 14,
  flexWrap: "wrap",
  background: "#fff7f2",
  border: "1px dashed #e9b9a5",
  borderRadius: 9,
  padding: 10,
  marginBottom: 10
};

const uploadSubtitle = {
  color: "#718096",
  marginTop: 4,
  fontSize: 12
};

const uploadControls = {
  display: "flex",
  gap: 10,
  alignItems: "center",
  flexWrap: "wrap"
};

const uploadButton = {
  padding: "9px 14px",
  background: "#c75028",
  color: "#ffffff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 650,
  fontSize: 12
};

const ticketGrid = {
  display: "grid",
  gap: 10
};

const ticketCard = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  background: "#ffffff",
  borderRadius: 9,
  padding: 13,
  border: "1px solid #e5eaf0"
};

const ticketIcon = {
  width: 42,
  height: 42,
  flexShrink: 0,
  borderRadius: 8,
  background: "#fff3ed",
  color: "#c75028",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 20
};

const ticketMeta = {
  color: "#718096",
  marginTop: 3,
  fontSize: 11
};

const ticketActions = {
  display: "flex",
  gap: 7
};

const smallAction = {
  width: 34,
  height: 34,
  borderRadius: 7,
  border: "1px solid #e5eaf0",
  background: "#f8fafc",
  color: "#475467",
  cursor: "pointer",
  fontSize: 15
};

const deleteAction = {
  width: 34,
  height: 34,
  borderRadius: 7,
  border: "1px solid #f4d0cd",
  background: "#fff1f0",
  color: "#c24136",
  cursor: "pointer",
  fontSize: 15
};

const emptyTicket = {
  textAlign: "center",
  padding: "16px 14px",
  color: "#718096",
  border: "1px dashed #d5dce5",
  borderRadius: 9,
  background: "#fafbfc"
};

const guestCardNew = {
  background: "#ffffff",
  borderRadius: 9,
  padding: 16,
  marginBottom: 10,
  border: "1px solid #e5eaf0",
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.02)",
  minWidth: 0
};

const guestTop = {
  display: "flex",
  alignItems: window.innerWidth < 768 ? "flex-start" : "center",
  flexDirection: window.innerWidth < 768 ? "column" : "row",
  gap: 12,
  marginBottom: 13
};

const guestAvatar = {
  width: 42,
  height: 42,
  flexShrink: 0,
  borderRadius: "50%",
  background: "#fff0e9",
  color: "#b74625",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 14,
  fontWeight: 750
};

const guestTitle = {
  margin: 0,
  fontSize: 15,
  fontWeight: 700,
  color: "#172033"
};

const guestBookingInfo = {
  color: "#8792a2",
  marginTop: 3,
  fontSize: 11
};

const bookingBadge = {
  background: "#fff7f2",
  border: "1px solid #f0d5c9",
  color: "#9d492d",
  padding: "6px 10px",
  borderRadius: 7,
  fontWeight: 700,
  fontSize: 12
};

const passengerRow = {
  display: "flex",
  flexWrap: "wrap",
  gap: 7,
  marginBottom: 10
};

const passengerChip = {
  background: "#f8fafc",
  padding: "6px 9px",
  borderRadius: 6,
  border: "1px solid #e5eaf0",
  color: "#475467",
  fontWeight: 550,
  fontSize: 11
};

const contactRow = {
  display: "flex",
  gap: 12,
  marginTop: 9,
  paddingTop: 9,
  borderTop: "1px solid #edf0f3",
  color: "#475467",
  fontSize: 12
};

const emptyGuests = {
  textAlign: "center",
  padding: "38px 18px",
  color: "#718096"
};

const emptyGuestsIcon = {
  fontSize: 38,
  marginBottom: 10,
  color: "#c75028"
};
